module.exports = __webpack_public_path__ + "img/4-2.b8e71f69.jpg";